import { getUserMembershipBadges } from '../utils/userMembershipBadges';

type UserMembershipBadgeListProps = {
  user: unknown;
};

export const UserMembershipBadgeList = ({
  user,
}: UserMembershipBadgeListProps) => (
  <>
    {getUserMembershipBadges(user).map((badge) => (
      <span
        key={badge.key}
        className={`mw-comment-badge ${badge.className}`}
        title={badge.title}
      >
        {badge.label}
      </span>
    ))}
  </>
);
